import React, { useMemo } from 'react';
import { useSearchParams } from 'react-router-dom';
import { categoryLabels, products } from '../data/products';
import { ProductCard } from '../components/ProductCard';
const filters = [{
  id: 'tout',
  label: 'Tout voir'
}, {
  id: 'laine',
  label: categoryLabels.laine
}, {
  id: 'crochet',
  label: categoryLabels.crochet
}, {
  id: 'mercerie',
  label: categoryLabels.mercerie
}, {
  id: 'puzzle',
  label: categoryLabels.puzzle
}];
export function Boutique() {
  const [params, setParams] = useSearchParams();
  const active = params.get('cat') ?? 'tout';
  const visible = useMemo(() => active === 'tout' ? products : products.filter(p => p.category === active), [active]);
  return <div className="mx-auto max-w-7xl px-4 py-12 sm:px-6" data-id="element-140" data-mp="o3lt33l7253s">
      <header className="max-w-2xl" data-id="element-141" data-mp="2nfo8o2qp6fc6">
        <h1 className="font-display text-5xl font-extrabold tracking-tight text-encre" data-id="element-142" data-mp="2nen0c612g6y5">
          {active === 'tout' ? 'La boutique' : categoryLabels[active]}
        </h1>
        <p className="mt-3 text-lg leading-relaxed text-encre-soft" data-id="element-143" data-mp="y8q8mzoak9ie">
          Pelotes, fils à broder, doudous crochetés et puzzles personnalisés — expédiés depuis
          Vouziers ou à récupérer en boutique.
        </p>
      </header>

      <nav aria-label="Filtrer par catégorie" className="mt-8 flex flex-wrap gap-2" data-id="element-144" data-mp="oblv1o8ihmd7">
        {filters.map(filter => {
        const isActive = active === filter.id;
        return <button key={filter.id} type="button" aria-pressed={isActive} onClick={() => setParams(filter.id === 'tout' ? {} : {
          cat: filter.id
        }, {
          replace: true
        })} className={['rounded-full px-4 py-2.5 text-sm font-bold transition-colors duration-150 ease-out', isActive ? 'bg-encre text-creme' : 'bg-white text-encre ring-1 ring-encre/12 hover:bg-creme-deep'].join(' ')} data-id="element-145" data-mp="1h011hmdkuwcx">
              {filter.label}
            </button>;
      })}
      </nav>

      <p className="mt-6 text-sm font-semibold text-encre-light" data-id="element-146" data-mp="29lg35i9i9zej">
        {visible.length} produit{visible.length > 1 ? 's' : ''}
      </p>

      <div className="mt-4 grid gap-6 sm:grid-cols-2 lg:grid-cols-3 xl:grid-cols-4" data-id="element-147" data-mp="24lbj5i9e2mjk">
        {visible.map(product => <ProductCard key={product.slug} product={product} data-id="element-148" data-mp="20ki0b3aszxxj" />)}
      </div>
    </div>;
}